import { render, staticRenderFns } from "./SPLoading.vue?vue&type=template&id=6533922d&scoped=true"
import script from "./SPLoading.vue?vue&type=script&lang=js"
export * from "./SPLoading.vue?vue&type=script&lang=js"
import style0 from "./SPLoading.vue?vue&type=style&index=0&id=6533922d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533922d",
  null
  
)

export default component.exports